import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { FaArrowUpLong } from 'react-icons/fa6';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if (!footer) {
        setVisible(false);
        return;
      }

      const footerRect = footer.getBoundingClientRect();
      const isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom >= 0;
      setVisible(isFooterVisible);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check visibility on mount

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={clsx('back-top', { 'back-top-show': visible })}
      style={{ display: visible ? 'flex' : 'none' }}
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
      aria-label="Back to top"
    >
      <FaArrowUpLong />
    </div>
  );
};

export default BackToTop;